import { ValidateFilter, ValidateFilterValue, ValidatedIcon } from "../../../../components/Controls/ValidateControl"
import { TextFilter } from "../../../../components/Form/FormStyles"
import { StickyHeader, CellWithValidator } from "../../../../components/Table/TableStyles"
import { EditedParticipation } from "../../../Partner/EditedPartner"
import { Filter } from "../../ParticipationFunctions/Filtering"
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles"

export function ImpactStoryInProgressHeader() {
	return (
		<StickyHeader
			style={{ ...offsetOneRow, width: '120px', minWidth: '120px', maxWidth: '120px' }}>
			Impact story - in progress
		</StickyHeader>
	)
}

export function ImpactStoryInProgressFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.ImpactStoryInProgressValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, ImpactStoryInProgressValidated: e.value })
					}
				/>
				<TextFilter
					value={filter?.HasImpactStoryInProgress ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, HasImpactStoryInProgress: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function ImpactStoryInProgressContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.ImpactStoryInProgressValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.HasImpactStoryInProgress ? 'Y' : ''}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}